module.exports = __webpack_public_path__ + "static/media/WheatStage119.7fe00598.PNG";